import { forgotPassword, forgotPasswordSubmit } from '../store/auth'
import { useDispatch, useSelector } from 'react-redux'
import { useEffect, useState } from 'react'
import Alert from 'react-bootstrap/Alert'
import Breadcrumb from '../components/Breadcrumb'
import Button from 'react-bootstrap/Button'
import Form from 'react-bootstrap/Form'
import { Helmet } from 'react-helmet'
import Spinner from '../components/Spinner'
import classNames from 'classnames'
import { initialize } from '../store/pagedata'
import styles from '../styles/signin.module.scss'
import useDarkMode from 'use-dark-mode'

const ForgotPassword = () => {
  const error = useSelector((state) => state.auth.error)
  const isLoading = useSelector((state) => state.auth.isLoading)
  const success = useSelector((state) => state.auth.success)
  const darkMode = useDarkMode(false)
  const dispatch = useDispatch()
  const [email, setEmail] = useState()

  useEffect(() => {
    dispatch(initialize())
  }, [])

  const onSubmit = (e) => {
    e.preventDefault()
    dispatch(forgotPassword(email))
  }

  return (
    <>
      <Helmet>
        <meta name='description' content='EDHREC Forgot Password' />
        <meta name='keywords' content='EDHREC,forgot,password' />
        <title>Forgot Password | EDHREC</title>
      </Helmet>
      <Breadcrumb breadcrumb={[{ '/forgot-password': 'Forgot Password' }]} />
      <h1 className='page-heading'>Forgot Password</h1>
      <div
        className={classNames(styles.container, {
          [styles.dark]: darkMode.value,
        })}
      >
        <div className={styles.containerInner}>
          <h2 className={styles.header}>Forgot Password</h2>
          <form onSubmit={onSubmit}>
            <Form.Group>
              <Form.Label>Email</Form.Label>
              <Form.Control
                onChange={(e) => setEmail(e.target.value)}
                placeholder='Email'
                type='text'
                value={email}
              />
            </Form.Group>
            <Form.Group>
              <Button
                className='btn-block'
                disabled={isLoading}
                type='submit'
                variant='primary'
              >
                {isLoading ? <Spinner /> : 'Submit'}
              </Button>
            </Form.Group>
            <Form.Group>
              {error && <Alert variant='danger'>{error}</Alert>}
              {success && <Alert variant='success'>{success}</Alert>}
            </Form.Group>
          </form>
        </div>
      </div>
    </>
  )
}

export default ForgotPassword
